import { Mutation } from 'vuex'
import nestedFreeze from '@/helpers/nestedFreeze'
import { SocialDistributionState } from '../types'

const setGroups: Mutation<SocialDistributionState> = (state, payload) => {
  state.groups = nestedFreeze(payload)
}

export default setGroups
